module.exports = __webpack_public_path__ + "static/media/be.3d797e0a.svg";